import { render, staticRenderFns } from "./SithMesSapAddressConfig.vue?vue&type=template&id=bc242c3a&scoped=true&"
import script from "./SithMesSapAddressConfig.vue?vue&type=script&lang=js&"
export * from "./SithMesSapAddressConfig.vue?vue&type=script&lang=js&"
import style0 from "./SithMesSapAddressConfig.vue?vue&type=style&index=0&id=bc242c3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc242c3a",
  null
  
)

export default component.exports